import React from 'react';
import { object, func, string, bool } from 'prop-types';
import { Modal } from 'antd';
import { Icon, Text, FlexContainer, Button } from '../../../common';
import OrderReception from './OrderReception';

const OrderReceptionModal = ({
    visible,
    onClose,
    order,
    pin,
    onPinChange,
    isPinReadOnly,
    quantities,
    onQuantityChange,
    onSubmit,
    loading,
    error,
    showSuccess,
    onErrorClose,
    onSuccessClose
}) => {
    const isSubmitDisabled = !pin || !order || loading;

    return (
        <Modal
            visible={visible}
            onCancel={onClose}
            title={null}
            closable={false}
            width={900}
            footer={null}
            destroyOnClose
            maskClosable={false}
        >
            {/* Header personalizado */}
            <FlexContainer 
                justify="space-between" 
                align="center" 
                style={{ 
                    padding: '16px 24px',
                    borderBottom: '1px solid #f0f0f0',
                    marginBottom: 24
                }}
            >
                <Text text="Recepción de Productos" strong size={18} />
                <Icon 
                    name='close' 
                    size={24} 
                    color='#666' 
                    style={{ cursor: 'pointer' }}
                    onClick={onClose}
                />
            </FlexContainer>

            <OrderReception
                order={order}
                pin={pin}
                onPinChange={onPinChange}
                isPinReadOnly={isPinReadOnly}
                quantities={quantities}
                onQuantityChange={onQuantityChange}
                onReset={onClose}
                onSubmit={onSubmit}
                loading={loading}
                error={error}
                showSuccess={showSuccess}
                isModal
                onErrorClose={onErrorClose}
                onSuccessClose={onSuccessClose}
                hideButtons
            />

            {/* Footer personalizado */}
            <FlexContainer 
                justify="flex-end" 
                gap={12}
                style={{ marginTop: 50 }}
            >
                <Button
                    text='Cancelar'
                    link
                    onClick={onClose}
                    disabled={loading}
                    style={{ fontSize: 12 }}
                    fitContent
                />
                <Button
                    text={loading ? 'Confirmando...' : showSuccess ? '✓ Confirmado' : 'Confirmar entrega'}
                    action='action_name'
                    backgroundColor='#1FA02E'
                    onClick={onSubmit}
                    disabled={isSubmitDisabled || showSuccess}
                    style={{ minWidth: 180, border: 0 }}
                    fitContent
                />
            </FlexContainer>
        </Modal>
    );
};

OrderReceptionModal.propTypes = {
    visible: bool.isRequired,
    onClose: func.isRequired,
    order: object,
    pin: string,
    onPinChange: func.isRequired,
    isPinReadOnly: bool,
    quantities: object.isRequired,
    onQuantityChange: func.isRequired,
    onSubmit: func.isRequired,
    loading: bool,
    error: string,
    showSuccess: bool,
    onErrorClose: func,
    onSuccessClose: func
};

OrderReceptionModal.defaultProps = {
    order: null,
    pin: '',
    isPinReadOnly: false,
    loading: false,
    error: null,
    showSuccess: false,
    onErrorClose: null,
    onSuccessClose: null
};

export default OrderReceptionModal;
